import React, { useState } from "react";
import { Link } from "react-router-dom";

export default function SelfieLink({ handleImageLoad }) {
  const [isLoaded, setIsLoaded] = useState(false);

  const handleImageLoaded = () => {
    setIsLoaded(true);
    handleImageLoad("selfieFrame");
  };

  return (
    <Link to={"/camera"} className="relative w-[90dvw] mx-auto">
      {/* Loading indicator */}
      {/* {!isLoaded && (
        <div className="absolute inset-0 flex justify-center items-center bg-gray-500">
          Loading...
        </div>
      )} */}
      <img
        src="./images/selfies-frame.webp"
        alt="selfie frame"
        className="h-full w-[100dvw] hidden"
        onLoad={handleImageLoaded}
      />
      {isLoaded && (
        <>
          <img
            src="./images/selfies-frame.webp"
            alt="selfie frame"
            className="h-full w-[100dvw]"
            // onLoad={handleImageLoaded}
            loading="lazy"
          />
          <div className="absolute top-0 bottom-0 flex flex-col justify-center gap-[0.8dvh] my-auto left-[3dvh] capitalize">
            <h1 className="text-black text-[2.3dvh] font-bold text-center">
              selfies
            </h1>
            <button className="text-white bg-[#A4907C] text-[1.7dvh] py-[.8dvh] px-[2.6dvh] font-bold rounded-[0.8dvh] capitalize">
              take selfie
            </button>
          </div>
        </>
      )}
      {/* Invisible img for preloading */}
      <img
        src="./images/selfies-frame.webp"
        alt="selfie frame preloader"
        className="hidden"
        onLoad={handleImageLoaded}
      />
    </Link>
  );
}
